export const ACTIONS = {
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR',
};

export const showSnackbar = payload => ({
  type: ACTIONS.SHOW_SNACKBAR,
  payload,
});

export const hideSnackbar = () => ({
  type: ACTIONS.HIDE_SNACKBAR,
  payload: {},
});
